module.exports = __webpack_public_path__ + "img/big3-7.3d0d500f.jpg";